var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAlertTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.5003L14.5 3.30031C13.6 2.00031 11.8 1.50031 10.4 2.30031C10 2.60031 9.7 2.90031 9.4 3.30031L0.9 17.5003C0.5 18.2003 0.4 19.0003 0.6 19.8003C0.8 20.6003 1.3 21.2003 1.9 21.6003C2.4 21.9003 2.9 22.1003 3.5 22.1003H20.4C22.1 22.1003 23.4 20.8003 23.4 19.1003C23.4 18.5003 23.2 17.9003 23 17.5003ZM20.4 20.0003H3.5C3.3 20.0003 3.2 20.0003 3 19.8003C2.8 19.7003 2.6 19.5003 2.6 19.2003C2.6 19.0003 2.5 18.8003 2.7 18.5003L11.2 4.40031C11.3 4.20031 11.4 4.10031 11.5 4.00031C12 3.70031 12.6 3.90031 12.9 4.30031L21.3 18.4003C21.4 18.5003 21.4 18.7003 21.4 18.8003C21.4 19.6003 21 20.0003 20.4 20.0003ZM12 8.00031C11.4 8.00031 11 8.40031 11 9.00031V13.0003C11 13.6003 11.4 14.0003 12 14.0003C12.6 14.0003 13 13.6003 13 13.0003V9.00031C13 8.40031 12.6 8.00031 12 8.00031ZM12 18.2503C12.6904 18.2503 13.25 17.6907 13.25 17.0003C13.25 16.3099 12.6904 15.7503 12 15.7503C11.3096 15.7503 10.75 16.3099 10.75 17.0003C10.75 17.6907 11.3096 18.2503 12 18.2503Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAlertTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconAlertTriangle.43d88652ad7fb2810b374a0c4066554c.svg";